import { computed, defineComponent, ref, onMounted, reactive } from 'vue';
import SVG from '@dts/shared/src/assets/svg';
import Typography from '@/components/TextFormat/FormatElements/Typography';
import styles from './index.module.scss';

import { usePermission } from '@/hooks/usePermission';
import { NPopover, NDrawer, NEllipsis } from 'naive-ui';
import Carousel from './components/Carousel/index.vue';
import NotificationDrawer from './components/NotificationDrawer';
import { useParentId } from '@/hooks/useParentId';
import { genStaticUrl } from '@dts/shared/src/utils/httpUrlConfig';
import { Close, Rectangle } from './components/Icon';
import { dashboardApi } from '@/api/modules/dashboard';

const Search = defineComponent({
  props: {
    showDrawer: {
      type: Boolean,
    },
  },
  emits: ['update:showDrawer'],
  setup: (props, context) => {
    onMounted(() => {
      getDailySaying();
      getNotificationList();
    });
    const { dtsUseDays, username } = usePermission();
    const showNotificationDrawer = ref(false);
    const currentNotification = ref({});
    const notifyTotal = ref<Number>(0);
    const dailySaying = ref<any>('');
    const newsList = ref<defs.dtsServer.DtsNewsInfoVo[]>([]);
    const { pid } = useParentId();

    const notificationList = ref<defs.dtsServer.DtsNotificationInfoVo[]>([]);
    // const emits = defineEmits(['close']);
    const userIcon = computed(() => {
      let name = '';
      if (username?.value.indexOf(',') === -1) {
        //没有逗号

        name = username?.value
          .split(' ')
          .map((word) => word.charAt(0))
          .join('');
      } else {
        //有逗号
        let parts = username?.value.split(',');
        name = parts[0].split(' ')[0][0] + parts[0].split(' ')[1][0];
      }
      return name;
    });

    const colseUserCenter = () => {
      context.emit('update:showDrawer', false);
    };

    const getNewsList = async () => {
      try {
        const res = await $dts.dtsNews.newsFrontPage.request(
          {},
          {
            sortByReleaseTime: 'desc',
            sortByPopularity: '',
            pageVo: {
              current: 1,
              size: 3,
            },
          },
        );
        newsList.value = res.data?.data ?? [];
      } catch (err) {
        console.error('getNewsList', err);
      }
    };
    const getDailySaying = async () => {
      try {
        const res = await $dts.dtsUser.dailySentence.request({}, {});

        dailySaying.value = res.data;
      } catch (err) {
        console.error('getDailySaying', err);
      }
    };
    const getNotificationList = async () => {
      try {
        const res = await $dts.dtsUser.dtsNotify.request({}, {});
        if (res?.data?.length) {
          if (res?.data?.length <= 20) {
            notificationList.value = res?.data ?? [];
          } else {
            notificationList.value = res?.data.slice(0, 20);
          }
        }

        notifyTotal.value = res?.data?.length ?? 0;

        // notificationList.value = [
        //   { type: 1, id: 1, message: 1 },
        //   { type: 1, id: 1, message: 1 },
        // ];
        //notifyTotal.value = 3;
        if (notifyTotal.value === 0) {
          getNewsList();
        }
      } catch (err) {
        console.error('getNewsList', err);
      }
    };
    const deleteNotify = async (val: any) => {
      try {
        await $dts.dtsUser.removeNote.request(
          {
            id: val.id,
          },
          {},
        );

        getNotificationList();
      } catch (err) {
        console.error('getDailySaying', err);
      }
    };

    // 点击轮播图，弹出通知。
    const openNotification = async (val: any) => {
      currentNotification.value = val;
      showNotificationDrawer.value = true;
      try {
        await $dts.dtsUser.onReadNote.request(
          {
            id: val.id,
          },
          {},
        );
      } catch (err) {
        console.error('onReadNote', err);
      }
    };

    const logoutDialog = reactive({
      show: false,
    });
    const logout = async () => {
      // const res = await $dts.login.loginOut.request({});
      // localStorage.clear();
      // window.location.href = res.data as string;
      logoutDialog.show = true;
    };

    const confirmLogout = async () => {
      const res = await $dts.login.loginOut.request({});
      localStorage.clear();
      window.location.href = res.data as string;
      logoutDialog.show = false;
    };

    return () => (
      <>
        <div class={styles.userCenter} id="drawer-notification-target">
          <div class={styles.bg1}>
            <div class={styles.content}>
              <div class={styles.topTitle}>
                <Typography.Text size={24} weight={700}>
                  User Center
                </Typography.Text>
                <div class={styles.close} onClick={colseUserCenter}>
                  <SVG.UserCenterClose />
                </div>
              </div>

              <div class={styles.userInfo}>
                <div class={styles.userInfoLeft}>
                  <div class={styles.nameImg}>{userIcon.value}</div>
                  <div class={styles.person}>
                    <div class={styles.personName}>
                      <Typography.Text size={16} weight={400}>
                        {username?.value}
                      </Typography.Text>
                    </div>
                    <div class={styles.personTime}>
                      <Typography.Text size={14} weight={300}>
                        Join in DTS {dtsUseDays?.value} Days
                      </Typography.Text>
                    </div>
                  </div>
                </div>
                <button class={styles.logout} onClick={logout}>
                  <img src={genStaticUrl('eraImages/icons/logout.svg')} alt="" />
                </button>
                <div class={styles.userInfoLine}>
                  <SVG.UserCenterLine />
                </div>
                <div class={styles.userInfoRight}>
                  <NEllipsis lineClamp={3} tooltip={false}>
                    {dailySaying.value}
                  </NEllipsis>
                </div>
              </div>
              <div class={styles.notification}>
                <div class={styles.top}>
                  <div class={styles.left}>
                    <Typography.Text size={24} weight={400} fontFamily="BMWTypeNext Condensed">
                      NOTIFICATION
                    </Typography.Text>
                  </div>
                  <div class={styles.right}>
                    <Typography.Text size={18} weight={400}>
                      All ({notifyTotal.value})
                    </Typography.Text>
                    <NPopover
                      trigger="hover"
                      delay={300}
                      raw
                      placement="top-start"
                      arrow-style={{
                        backgroundColor: '#333333E5',
                        position: ' relative',
                        left: '1.74rem',
                      }}
                    >
                      {{
                        trigger: () => (
                          <>
                            <SVG.UserCenterTips />
                          </>
                        ),
                        default: () => (
                          <>
                            <div class={styles.popover}>
                              <Typography.Text size={12} weight={400}>
                                Only display the latest 20 items.
                              </Typography.Text>
                            </div>
                          </>
                        ),
                      }}
                    </NPopover>
                  </div>
                </div>
                {notificationList.value.length === 0 ? (
                  <div class={styles.noNotification}>
                    <div class={styles.noMore}>
                      <SVG.UserCenterSmile />
                      <Typography.Text size={18} weight={400}>
                        No more notifications
                      </Typography.Text>
                    </div>
                    <div class={styles.welcome}>
                      <Typography.Text size={18} weight={400}>
                        Welcome to explore more in DTS：
                      </Typography.Text>
                    </div>

                    <div class={styles.news}>
                      {newsList.value.map((item) => (
                        <div
                          class={styles.newsItem}
                          onClick={() => {
                            if (item.links?.length) {
                              $dts.dtsNews.viewCount.request({
                                id: item.id as number,
                                pageId: 121,
                              });
                              if (item.links[0] === '/extra/newsDetail') {
                                window.open(
                                  `/extra/newsDetail?id=${item.id}${pid.value}`,
                                  '_blank',
                                );
                              } else {
                                window.open(`${item.links[0]}`, '_blank');
                              }
                            }
                          }}
                        >
                          <img src={item?.newImages?.[0]} alt="" />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div class={styles.carouselBox}>
                    <Carousel
                      class={styles.carousel}
                      list={notificationList.value}
                      onOpenNotification={openNotification}
                      onDeleteNotification={deleteNotify}
                    />
                  </div>
                )}
              </div>
              <div class={styles.mayAsk}>
                <div class={styles.askTitle}>
                  <Typography.Text size={24} weight={400} fontFamily="BMWTypeNext Condensed">
                    YOU MAY ALSO LIKE
                  </Typography.Text>
                </div>
                <div class={styles.askBox}>
                  <div
                    class={styles.askItem}
                    onClick={() => {
                      dashboardApi.recordActionBrowse({
                        buttonId: 123,
                        entity: '/extra/Strategy',
                        pageId: 121,
                        type: 7,
                      });
                      window.open('/extra/Strategy', 'blank');
                    }}
                  >
                    <div class={styles.desc}>
                      <div> Data & AI</div>
                      <div> Strategy</div>
                    </div>
                    <div class={styles.buttomIcon}>
                      <SVG.UserCenterStrategy class={styles.diaplay} />
                      <SVG.UserCenterStrategy2 class={styles.diaplayHover} />
                    </div>
                  </div>
                  <div
                    class={styles.askItem}
                    onClick={() => {
                      dashboardApi.recordActionBrowse({
                        buttonId: 123,
                        entity: '/extra/data',
                        pageId: 121,
                        type: 7,
                      });

                      window.open('/extra/data', 'blank');
                    }}
                  >
                    <div class={styles.desc}>
                      <div> Become an Expert</div>
                      <div> in Data Transformation</div>
                    </div>
                    <div class={styles.buttomIcon}>
                      <SVG.UserCenterData class={styles.diaplay} />
                      <SVG.UserCenterData2 class={styles.diaplayHover} />
                    </div>
                  </div>
                  <div
                    class={styles.askItem}
                    onClick={() => {
                      dashboardApi.recordActionBrowse({
                        buttonId: 123,
                        entity: '/extra/ai',
                        pageId: 121,
                        type: 7,
                      });

                      window.open('/extra/ai', 'blank');
                    }}
                  >
                    <div class={styles.desc}>
                      <div> All You Need</div>
                      <div> to know about AI</div>
                    </div>
                    <div class={styles.buttomIcon}>
                      <SVG.UserCenterAi class={styles.diaplay} />
                      <SVG.UserCenterAi2 class={styles.diaplayHover} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*   <img src={bg1} alt="userCenter" class={styles.bg1} /> */}

          {/*      <Editor onUpdataValue={change} /> */}
          <NDrawer
            show={showNotificationDrawer.value}
            placement="right"
            on-mask-click={() => (showNotificationDrawer.value = false)}
            default-width="5.08rem"
            to="#drawer-notification-target"
            show-mask={true}
          >
            <NotificationDrawer
              showDrawer={showNotificationDrawer.value}
              notification={currentNotification.value}
              native-scrollbar
              onUpdate:showNotificationDrawer={(val) => (showNotificationDrawer.value = val)}
            />
          </NDrawer>

          {logoutDialog.show && (
            <div class={styles.signOutDialogContainer}>
              <div class={styles.dialog}>
                <div class={styles.header}>
                  <div class={styles.left}>
                    <span>Sign out</span>
                    <div class={styles.rectangle}>
                      <Rectangle />
                    </div>
                  </div>
                  <button
                    class={styles.close}
                    onClick={() => {
                      logoutDialog.show = false;
                    }}
                  >
                    <Close />
                  </button>
                </div>
                <div class={styles.confirmText}>Please confirm if you want to log out.</div>
                <div class={styles.buttons}>
                  <button class={styles.confirm} onClick={confirmLogout}>
                    Confirm
                  </button>
                  <button
                    class={styles.cancel}
                    onClick={() => {
                      logoutDialog.show = false;
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div class={styles.cover}></div>
            </div>
          )}
        </div>
      </>
    );
  },
});

export default Search;
